import {createAllActions} from 'web-app/util/redux/typed-action-helpers';
import type BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

export const {success: fetchAccountSuccess} = createAllActions(
    'ACCOUNT/FETCH_ACCOUNT',
    () => ({}),
    (account: {loginId: string; behaviors: BehaviorsCollection}) => ({account}),
);
